document.addEventListener('DOMContentLoaded', function () {

  let popupSliders = [];

  // Open Popup
  document.querySelectorAll('.column').forEach(function (column) {
    column.addEventListener('click', function () {

      const popupId = this.getAttribute('data-popup-id');

      const popup = document.querySelector(
        `.section-popup[popup-data-id="${popupId}"]`
      );

      if (!popup) return;

      popup.classList.add('active');
      document.querySelector('.section-popup-overlay')?.classList.add('active');

      // Destroy old sliders if already initialized
      popupSliders.forEach(slider => {
        if (slider && !slider.destroyed) {
          slider.destroy(true, true);
        }
      });

      popupSliders = [];

      // Init sliders inside opened popup
      popup.querySelectorAll('.popup-slide-slider').forEach(function (sliderEl) {

        const swiper = new Swiper(sliderEl, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 10,
            observer: true,
            autoHeight: true,
            observeParents: true,
            effect: "fade",
            fadeEffect: {
              crossFade: true,
            }
            
        });

        popupSliders.push(swiper);

        // Next buttons
        sliderEl.querySelectorAll('.popup-button-next').forEach(btn => {
          btn.addEventListener('click', () => {
            swiper.slideNext();
          });
        });

        // Back button
        const backBtn = popup.querySelector('.section-popup-backbutton');
        backBtn?.addEventListener('click', () => {
          swiper.slidePrev();
        });

        swiper.on('slideChange', function () {
          if (swiper.isBeginning) {
            backBtn.classList.add('swiper-button-disabled');
          } else {
            backBtn.classList.remove('swiper-button-disabled');
          }
        });

        });

    });
  });

  // Close Popup Function
   function closePopup() {
    document.querySelectorAll('.section-popup.active').forEach(popup => popup.classList.remove('active'));
    document.querySelector('.section-popup-overlay')?.classList.remove('active');

    setTimeout(() => {
    popupSliders.forEach(slider => {
      if (slider && !slider.destroyed) {
        slider.destroy(true, true);
      }
    });

    popupSliders = [];
    }, 500);
  }

  document.querySelectorAll('.popup-close-button').forEach(function (btn) {
    btn.addEventListener('click', closePopup);
  });

  document.querySelector('.section-popup-overlay')?.addEventListener('click', closePopup);

});